import localforage from 'localforage'

export default {
  methods: {
    async checkUnfinishedUploads(store) {
      const currentTasks = await localforage.getItem(store) || {}
      if (Object.keys(currentTasks).length > 0) {
        Object.keys(currentTasks).forEach(async (slideId) => {
          if (currentTasks[slideId] &&
            currentTasks[slideId].presentationId &&
            currentTasks[slideId].retryTime < 3 &&
            this.presentation &&
            this.presentation.id === currentTasks[slideId].presentationId
          ) {
            await this.handleUpdateInBackground(currentTasks[slideId], slideId)
          }
        })
      }
    },

    async addUploadTask(slideId, presentationId, data, store) {
      const currentTasks = await localforage.getItem(store) || {}
      currentTasks[slideId] = data
      currentTasks[slideId].presentationId = presentationId
      currentTasks[slideId].retryTime = 0
      await localforage.setItem(store, currentTasks)
    },

    async increaseRetryTime(slideId, store) {
      const currentTasks = await localforage.getItem(store) || {}
      const currentRetryCount = currentTasks[slideId].retryTime
      currentTasks[slideId].retryTime = currentRetryCount + 1
      await localforage.setItem(store, currentTasks)
    },

    async removeUploadTask(slideId, store) {
      const currentTasks = await localforage.getItem(store) || {}
      if (currentTasks[slideId]) {
        delete currentTasks[slideId]
      }
      await localforage.setItem(store, currentTasks)
    },
  },
}
